/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Componente_a4_97_52 as Componente_a4_97_52,
  rec_Dr as Dr,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Za as Za,
  rec_api as api,
  rec_z$ as z$,
} from "../../runtime/index.jsx";
export function FotoPuesto({ fila: e, onCambio: t }) {
  let n = Go(),
    { confirmar: r } = Fo(),
    i = (0, React.useRef)(null),
    [a, o] = (0, React.useState)(!1);
  async function s(r) {
    o(!0);
    try {
      let i = new FormData();
      (i.append(`foto`, await z$(r)),
        t(
          await Za(`/organigrama/${e.id}/foto`, i, {
            topeMs: 6e4,
          }),
        ),
        n.ok(`Foto guardada`));
    } catch (e) {
      n.error(e.message);
    } finally {
      o(!1);
    }
  }
  async function c() {
    if (
      await r({
        titulo: `Quitar la foto`,
        mensaje: `Esta persona se va a ver con sus iniciales.`,
        confirmarTexto: `Quitar`,
      })
    )
      try {
        (t(
          await api(`/organigrama/${e.id}/foto`, {
            method: `DELETE`,
          }),
        ),
          n.ok(`Foto quitada`));
      } catch (e) {
        n.error(e.message);
      }
  }
  return (
    <div
      className={`flex flex-wrap items-center gap-4`}
      children={[
        <Componente_a4_97_52 fila={e} tamano={`h-20 w-20 text-2xl`} />,
        <div
          className={`flex flex-wrap gap-2`}
          children={[
            <input
              ref={i}
              type={`file`}
              accept={`image/jpeg,image/png,image/webp`}
              aria-label={`Foto de perfil`}
              className={`sr-only`}
              onChange={(e) => {
                let t = e.target.files?.[0];
                ((e.target.value = ``), t && s(t));
              }}
            />,
            <AccionAsync
              variante={`secundario`}
              className={`min-h-11`}
              icono={Dr}
              ocupado={a}
              textoOcupado={`Subiendo…`}
              onClick={() => i.current?.click()}
              children={e.fotoVersion ? `Cambiar foto` : `Subir foto`}
            />,
            e.fotoVersion && (
              <AccionAsync
                variante={`texto`}
                className={`min-h-11`}
                onClick={c}
                children={`Quitar foto`}
              />
            ),
          ]}
        />,
      ]}
    />
  );
}
